import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Grid, TextField } from '@mui/material';
import { FormContainer, RowContainer, BaseLabel, Label, cores } from '../../../styles/styleUtils'; // Reutilizando seus estilos
import ActionButtons from '../components/ActionButtons';
import ServiceData from '../components/ServiceData';


const Style1 = styled(TextField)`
  width: 70%;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: ${cores.branco};
  & .MuiInputBase-root {
    height: 36px;
    padding: 1.5px;
  }
`;

// Componente
const Servicos = React.forwardRef((props, ref) => {
  const getInititalState = () => ({
    valorDeslocamento: props.proposta.valorDeslocamento || 0, 
    subTotalServicos: props.proposta.subTotalServicos || 0,
    valorServico: props.proposta.valorServico || 0,
    kmRodado: props.proposta.kmRodado || 0,
    servicos: props.proposta.servicos || [],
  })
  const [disableConfirm, setDisableConfirm] = useState(true);
  const [formData, setFormData] = useState(getInititalState())

  // --- Lógica de Submissão ---

  const handleSubmit = async () => {
    props.onConfirm(formData);
    props.onClose();
  };

  const handleCancel = () => {
    if (window.confirm('Tem certeza que deseja sair? As alterações não salvas serão perdidas')) {
      getInititalState();
      props.onClose();
    }
  };

  // --- Validação ---
  useEffect(() => {
    if (formData.servicos?.length > 0) {
      setDisableConfirm(false);
    } else {
      setDisableConfirm(true);
    }
  }, [formData]);

  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <FormContainer>
        <RowContainer>
          <Label htmlFor="cliente">Cliente</Label>
          <Style1 id="cliente" name="cliente" value={props.proposta.cliente.nome || null} disabled />
        </RowContainer>
        {/* --- Seção Detalhes da OS --- */}
        <Grid container spacing={2} >
          <Grid item xs={12} md={3}>
            <BaseLabel>Código</BaseLabel>
            <Style1
              name="codigo"
              value={props.proposta.codigo}
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel htmlFor="unidade">Unidade</BaseLabel>
            <Style1 id="unidade" value={props.proposta.unidade.nome || null} disabled />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Cidade</BaseLabel>
            <Style1
              name="cidade"
              value={props.proposta.cliente?.cidade?.nome}
              fullWidth
              placeholder="Ex: Uberlândia"
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Telefone</BaseLabel>
            <Style1
              name="telefone"
              value={props.proposta.cliente?.telefone}
              fullWidth
              placeholder="(XX) XXXX-XXXX"
              // TODO: Adicionar máscara de telefone (ex: react-input-mask)
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BaseLabel>Classificação</BaseLabel>
            <Style1 id="classificacao" value={props.proposta.classificacao.nome || null} disabled />
          </Grid>

          <Grid item xs={12} md={6}>
            {''}
          </Grid>
        </Grid>
        {/* Servicos */}
        <Grid container  sx={{ mt: 3, mb: 3 }}>
          <ServiceData formData={formData} setFormData={setFormData} />
        </Grid>

        {/* --- Botões de Ação --- */}
        <ActionButtons
          onCancel={handleCancel}
          onConfirm={handleSubmit}
          disableConfirm={disableConfirm}
          visualiza={props.visualiza}
        />
      </FormContainer>
    </Modal>
  );
});

export default Servicos;